import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DarkSiteAem } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { Logo } from './models/logo.interfaces';

@Component({
  selector: 'idp-logo',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent {
  @Input() mobileDarkSiteLogo: DarkSiteAem = {} as DarkSiteAem;
  @Input() isBusiness = false;
  @Input() content: Logo = {} as Logo;
  @Input() vacationHeader = false;

  @Output() homeClick = new EventEmitter<void>();
  @Output() openPopup = new EventEmitter<{ url: string; showPopup: boolean }>();
  @Output() analyticsEvent = new EventEmitter<HTMLElement>();
  readonly fallbackImage =
    'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

  homeClicked(): void {
    this.homeClick.emit();
  }

  open(url?: string, showPopup?: boolean): void {
    this.openPopup.emit({ url: url || '', showPopup: !!showPopup });
  }

  analyticsEventEmit(element: HTMLElement): void {
    this.analyticsEvent.emit(element);
  }
}
